import lozadInitiator from "../global/lozadInitiator";
import animations from "../global/animations";
import modals from "../global/modals";
import accordions from "../global/accordions";
import playFullscreen from "../global/vimeoPlayer";

const ICON_GRID = '<svg class="icon-grid" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M5.33337 6.66671C5.33337 6.31309 5.47385 5.97395 5.7239 5.7239C5.97395 5.47385 6.31309 5.33337 6.66671 5.33337H12C12.3537 5.33337 12.6928 5.47385 12.9428 5.7239C13.1929 5.97395 13.3334 6.31309 13.3334 6.66671V12C13.3334 12.3537 13.1929 12.6928 12.9428 12.9428C12.6928 13.1929 12.3537 13.3334 12 13.3334H6.66671C6.31309 13.3334 5.97395 13.1929 5.7239 12.9428C5.47385 12.6928 5.33337 12.3537 5.33337 12V6.66671Z" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.6667 6.66671C18.6667 6.31309 18.8072 5.97395 19.0572 5.7239C19.3073 5.47385 19.6464 5.33337 20 5.33337H25.3334C25.687 5.33337 26.0261 5.47385 26.2762 5.7239C26.5262 5.97395 26.6667 6.31309 26.6667 6.66671V12C26.6667 12.3537 26.5262 12.6928 26.2762 12.9428C26.0261 13.1929 25.687 13.3334 25.3334 13.3334H20C19.6464 13.3334 19.3073 13.1929 19.0572 12.9428C18.8072 12.6928 18.6667 12.3537 18.6667 12V6.66671Z" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.33337 20C5.33337 19.6464 5.47385 19.3073 5.7239 19.0572C5.97395 18.8072 6.31309 18.6667 6.66671 18.6667H12C12.3537 18.6667 12.6928 18.8072 12.9428 19.0572C13.1929 19.3073 13.3334 19.6464 13.3334 20V25.3334C13.3334 25.687 13.1929 26.0261 12.9428 26.2762C12.6928 26.5262 12.3537 26.6667 12 26.6667H6.66671C6.31309 26.6667 5.97395 26.5262 5.7239 26.2762C5.47385 26.0261 5.33337 25.687 5.33337 25.3334V20Z" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.6667 20C18.6667 19.6464 18.8072 19.3073 19.0572 19.0572C19.3073 18.8072 19.6464 18.6667 20 18.6667H25.3334C25.687 18.6667 26.0261 18.8072 26.2762 19.0572C26.5262 19.3073 26.6667 19.6464 26.6667 20V25.3334C26.6667 25.687 26.5262 26.0261 26.2762 26.2762C26.0261 26.5262 25.687 26.6667 25.3334 26.6667H20C19.6464 26.6667 19.3073 26.5262 19.0572 26.2762C18.8072 26.0261 18.6667 25.687 18.6667 25.3334V20Z" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const ICON_LIST = '<svg class="icon-list" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M11.9998 8H26.6665M11.9998 16H26.6665M11.9998 24H26.6665M6.6665 8V8.01333M6.6665 16V16.0133M6.6665 24V24.0133" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const ICON_ARROW_PREV = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 6L9 12L15 18" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const ICON_ARROW_NEXT = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="#7248BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const angle = {
    init() {
        this.initPlayIcons(document);
        this.initRowTitleTap(document);
        this.initScrollButtons();
        this.initEpisodesWrapper();
    },

    initRowTitleTap(scope) {
        scope.querySelectorAll('.angle-episode-row .info h3').forEach((title) => {
            if (title.dataset.angleBound) {
                return;
            }

            title.dataset.angleBound = '1';

            title.onclick = (e) => {
                if (!window.matchMedia('(max-width: 992px)').matches) {
                    return;
                }

                const playIcon = title.closest('.angle-episode-row')?.querySelector('.embed-play-icon');

                if (!playIcon) {
                    return;
                }

                e.stopPropagation();
                playIcon.click();
            };
        });
    },

    initPlayIcons(scope) {
        scope.querySelectorAll('.embed-play-icon').forEach((playIcon) => {
            if (playIcon.dataset.angleBound) {
                return;
            }

            playIcon.dataset.angleBound = '1';

            const videoUrl = playIcon.getAttribute('data-url');
            const shouldAutoplayFullscreen = !!playIcon.closest('.angle-episode-card, .angle-episode-row, #angle-featured-video');

            playIcon.onclick = (e) => {
                if (!videoUrl) {
                    return;
                }

                e.stopPropagation();

                const container = playIcon.parentNode;
                container.innerHTML = '<iframe frameborder="0" class="embed-responsive-item" src="' + videoUrl + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';

                if (shouldAutoplayFullscreen) {
                    playFullscreen(container.querySelector('iframe'));
                }
            };
        });
    },

    initScrollButtons() {
        document.querySelectorAll('.js-angle-scroll').forEach((button) => {
            button.onclick = () => {
                const target = document.querySelector(button.getAttribute('data-scroll-target'));

                if (!target) {
                    return;
                }

                target.scrollIntoView({ behavior: 'smooth', block: 'start' });

                if (button.getAttribute('data-action') === 'play') {
                    const playIcon = target.querySelector('.embed-play-icon');

                    if (playIcon) {
                        playIcon.click();
                    }
                }
            };
        });
    },

    initEpisodesWrapper() {
        const wrapper = document.getElementById('angle-episodes-wrapper');

        if (!wrapper) {
            return;
        }

        const gridEl = wrapper.querySelector('.angle-episodes__grid');
        const listEl = wrapper.querySelector('.angle-episodes__list');
        const pagerWrapper = wrapper.parentElement.querySelector('.angle-episodes__pagination-wrapper');
        const sortToggle = wrapper.parentElement.querySelector('.js-angle-sort');
        const viewToggle = wrapper.parentElement.querySelector('.js-angle-view-toggle');

        const state = {
            view: wrapper.getAttribute('data-view') || 'grid',
            order: wrapper.getAttribute('data-order') || 'desc',
            page: 1,
        };

        const perPageFor = (view) => parseInt(wrapper.getAttribute(view === 'list' ? 'data-per-page-list' : 'data-per-page-grid'), 10) || (view === 'list' ? 4 : 9);

        const activeContainer = () => ('list' === state.view ? listEl : gridEl);

        let requestId = 0;

        const setLoading = (isLoading) => {
            wrapper.classList.toggle('is-loading', isLoading);

            [sortToggle, viewToggle].forEach((button) => {
                if (button) {
                    button.disabled = isLoading;
                }
            });

            if (pagerWrapper && isLoading) {
                // Only disable while loading - the pager is rebuilt from fresh HTML
                // (with correct per-button disabled state) once the response lands.
                pagerWrapper.querySelectorAll('.js-angle-page').forEach((button) => {
                    button.disabled = true;
                });
            }
        };

        const fetchEpisodes = ({ showLoading = true } = {}) => {
            const thisRequestId = ++requestId;

            if (showLoading) {
                setLoading(true);
            }

            fetch(cdScriptsObj.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({
                    action: 'searchAngleEpisodes',
                    paged: state.page,
                    order: state.order,
                    view: state.view,
                    per_page: perPageFor(state.view),
                }),
            }).then((response) => response.json()).then((results) => {
                if (thisRequestId !== requestId) {
                    // A newer request has since been fired - drop this stale response.
                    return;
                }

                const container = activeContainer();

                if (container) {
                    container.innerHTML = results.cards;
                    this.initPlayIcons(container);
                    this.initRowTitleTap(container);
                    modals.init();
                    accordions.init();
                    lozadInitiator.init();
                    animations.init();
                }

                if (pagerWrapper) {
                    pagerWrapper.innerHTML = angle.buildPaginationHTML(results.paged, results.max_num_pages);
                    pagerWrapper.classList.toggle('hide', !pagerWrapper.innerHTML);
                }
            }).catch((err) => console.error(err)).finally(() => {
                if (thisRequestId === requestId && showLoading) {
                    setLoading(false);
                }
            });
        };

        if (pagerWrapper) {
            pagerWrapper.addEventListener('click', (e) => {
                const pageButton = e.target.closest('.js-angle-page');

                if (!pageButton || pageButton.disabled) {
                    return;
                }

                const page = parseInt(pageButton.getAttribute('data-page'), 10);

                if (!page || page === state.page) {
                    return;
                }

                state.page = page;
                fetchEpisodes();
            });
        }

        if (sortToggle) {
            sortToggle.onclick = () => {
                state.order = 'desc' === state.order ? 'asc' : 'desc';
                state.page = 1;
                sortToggle.setAttribute('data-order', state.order);
                wrapper.setAttribute('data-order', state.order);
                fetchEpisodes();
            };
        }

        if (viewToggle) {
            viewToggle.onclick = () => {
                state.view = 'grid' === state.view ? 'list' : 'grid';
                state.page = 1;
                viewToggle.setAttribute('data-view', state.view);
                wrapper.setAttribute('data-view', state.view);
                viewToggle.innerHTML = 'list' === state.view ? ICON_GRID : ICON_LIST;

                if (gridEl) {
                    gridEl.classList.toggle('hide', 'grid' !== state.view);
                }

                if (listEl) {
                    listEl.classList.toggle('hide', 'list' !== state.view);
                }

                if (pagerWrapper) {
                    const maxPages = parseInt(wrapper.getAttribute('list' === state.view ? 'data-max-pages-list' : 'data-max-pages-grid'), 10) || 1;
                    pagerWrapper.innerHTML = angle.buildPaginationHTML(1, maxPages);
                    pagerWrapper.classList.toggle('hide', !pagerWrapper.innerHTML);
                }

                // Page 1 of both views is already pre-rendered server-side and swaps
                // in instantly above - this just silently re-syncs it (e.g. in case the
                // sort order changed since that view was last rendered), so it shouldn't
                // dim/flash the content the user can already see.
                fetchEpisodes({ showLoading: false });
            };
        }
    },

    buildPaginationHTML(currentPage, maxNumPages) {
        currentPage = parseInt(currentPage, 10) || 1;
        maxNumPages = parseInt(maxNumPages, 10) || 1;

        if (maxNumPages < 2) {
            return '';
        }

        const windowSize = 5;
        let start = Math.max(1, Math.min(currentPage - Math.floor(windowSize / 2), maxNumPages - windowSize + 1));
        start = Math.max(1, start);
        const end = Math.min(maxNumPages, start + windowSize - 1);

        const prevPage = Math.max(1, currentPage - 1);
        const nextPage = Math.min(maxNumPages, currentPage + 1);
        const isFirst = 1 === currentPage;
        const isLast = currentPage === maxNumPages;

        const prevButton = `<button type="button" class="page-arrow js-angle-page prev" data-page="${prevPage}"${isFirst ? ' disabled' : ''} aria-label="Previous page">${ICON_ARROW_PREV}</button>`;
        const nextButton = `<button type="button" class="page-arrow js-angle-page next" data-page="${nextPage}"${isLast ? ' disabled' : ''} aria-label="Next page">${ICON_ARROW_NEXT}</button>`;

        let html = '<nav class="angle-episodes-pagination" aria-label="Episodes pagination">';

        html += '<div class="angle-episodes-pagination__numbered">';
        html += prevButton;

        if (start > 1) {
            html += `<button type="button" class="page-number js-angle-page" data-page="1">1</button>`;

            if (start > 2) {
                html += '<span class="ellipsis">&hellip;</span>';
            }
        }

        for (let page = start; page <= end; page++) {
            html += `<button type="button" class="page-number js-angle-page${page === currentPage ? ' active' : ''}" data-page="${page}"${page === currentPage ? ' aria-current="page"' : ''}>${page}</button>`;
        }

        if (end < maxNumPages) {
            if (end < maxNumPages - 1) {
                html += '<span class="ellipsis">&hellip;</span>';
            }

            html += `<button type="button" class="page-number js-angle-page" data-page="${maxNumPages}">${maxNumPages}</button>`;
        }

        html += nextButton;
        html += '</div>';

        html += '<div class="angle-episodes-pagination__simple">';
        html += prevButton;
        html += `<span class="page-current-box">${currentPage}</span>`;
        html += `<span class="page-of-text">of ${maxNumPages}</span>`;
        html += nextButton;
        html += '</div>';

        html += '</nav>';

        return html;
    },
};

angle.init();
